import { Injectable } from '@angular/core';

import { Attribute } from '@shared/models/attribute';
import { comparator } from '@shared/utils/comparator';
import { InspectionAttributeAssignment } from '@inspections/models/inspection-attribute-assignment';

@Injectable()
export class InspectionAttributeAssignmentsSortingService {
  /**
   * Sorts the assignments based on the order of inspection attributes.
   * Sorting will be made based on the order of provided inspection attributes.
   * The sorting is not made based on 'Order' property of the inspection attribute to avoid the need to
   * change logic here if ordering (asc, desc) of the inspection attributes changes in the future.
   */
  sort(
    assignments: InspectionAttributeAssignment[],
    attributes: Attribute[]
  ): InspectionAttributeAssignment[] {
    return [...assignments].sort(
      (a: InspectionAttributeAssignment, b: InspectionAttributeAssignment) => {
        const valueA = this.sortAccessor(a, attributes);
        const valueB = this.sortAccessor(b, attributes);

        return comparator(valueA, valueB);
      }
    );
  }

  /**
   * Sort by order in the inspection attributes instead of order property
   */
  private sortAccessor(
    assignment: InspectionAttributeAssignment,
    attributes: Attribute[]
  ): number {
    return attributes?.findIndex(x => x.id === assignment.attributeId);
  }
}
